import request from '@/utils/service'

export function list(data) {
  return request({
    url: '/card/list',
    method: 'get',
    params: data
  })
}

export function orderList(data) {
  return request({
    url: '/card/OrderList',
    method: 'get',
    params: data
  })
}

export function delCard(data) {
  return request({
    url: '/card/delete',
    method: 'post',
    data
  })
}

export function addCard(data) {
  return request({
    url: '/card/add',
    method: 'post',
    data
  })
}
export function bandCard(data) {
  return request({
    url: '/card/bandCard',
    method: 'post',
    data
  })
}

export function unBandCard(data) {
  return request({
    url: '/card/unBand',
    method: 'post',
    data
  })
}


export function setValid(data) {
  return request({
    url: '/card/setValid',
    method: 'post',
    data
  })
}

export function setInvalid(data) {
  return request({
    url: '/card/setInvalid',
    method: 'post',
    data
  })
}

export function delElectricCard(data) {
  return request({
    url: '/card/deleteCard',
    method: 'post',
    data
  })
}
